import { render, staticRenderFns } from "./school_club_list.vue?vue&type=template&id=cda4e134&"
import script from "./school_club_list.vue?vue&type=script&lang=js&"
export * from "./school_club_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports